// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart canvas {
  display: block !important;
  padding: 20px;
  position: relative;
  height: 380px !important;
  width: auto !important;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 1rem;
  margin-top: 1rem;
}

.card {
  flex: 1 1 calc(33% - 1rem);
  max-width: calc(33% - 1rem);
  min-width: 240px;
  box-sizing: border-box;
  padding: 1rem;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px #36f;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 3px solid #36f !important;
}

.card:hover {
  padding-top: 20px;
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Tablet view */
@media (max-width: 992px) {
  .card {
    flex: 1 1 calc(50% - 1rem);
    max-width: calc(50% - 1rem);
  }
}
/* Mobile view */
@media (max-width: 576px) {
  .card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
.rule-id {
  font-size: 0.9rem;
  color: #777;
}

.criteria-block {
  margin-top: 0.75rem;
}

.progress-bar-container {
  display: flex;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background: #e0e0e0;
}

.progress-bar {
  height: 100%;
}

.blue {
  background-color: #36f;
}

.red {
  background-color: red;
}

.custom-select-container {
  position: relative;
  max-width: 200px; /* Adjust as needed */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#typeFilter {
  width: 100%;
  padding: 6px 32px 6px 12px;
  border: 1px solid #36f;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  -webkit-appearance: none;
          appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23444' d='M2 0L0 2h4L2 0zM2 5L0 3h4l-2 2z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 8px 10px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#typeFilter:focus {
  outline: none;
  border-color: #36f;
  box-shadow: 0 0 0 2px rgba(51, 102, 255, 0.2);
}

.filter-row {
  display: flex;
  align-items: end;
  justify-content: end;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detailsBtn {
  color: #36f;
  background-color: white;
  padding: 6px 12px;
  border: 1px solid #36f;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.detailsBtn:hover {
  color: white;
  background-color: #36f;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.backBtn {
  color: #36f;
  background-color: white;
  padding: 6px 12px;
  border: 1px solid #36f;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.backBtn:hover {
  background-color: #36f;
  color: white;
}

.back-button-wrapper {
  flex: 1;
}

.card h4 {
  text-align: center;
  color: rgb(198, 187, 9);
}

.info-row {
  font-size: 15px;
  margin: 4px 0;
  text-align: center;
}
.info-row .label {
  min-width: 70px;
  font-weight: bold;
}
.info-row .value {
  flex: 1;
}

.calenderIcons {
  color: #36f;
  background-color: white;
  padding: 6px 12px;
  border: 1px solid #36f;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.calenderIcons:hover {
  color: white;
  background-color: #36f;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.calenderIcons:focus {
  color: white;
  background-color: #36f;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.form-popup {
  display: none;
  position: fixed;
  width: 250px;
  top: 21%;
  right: 3%;
  border: 3px solid #f1f1f1;
  z-index: 9;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.btn-submit {
  background-color: #007bff !important;
  color: white !important;
  transition: background-color 0.3s ease;
  margin: 10px;
}

.btn-submit.btn-disabled,
.btn-submit:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
  border: none;
}

.calenderIConCLicked.btn-enabled {
  color: white;
  background-color: #36f;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/contest-and-incentive-details/shortfall/shortfall.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;EAEA,qDAAA;EACA,iCAAA;AAAF;;AAGA;EACE,iBAAA;EAEA,wCAAA;EACA,yCAAA;AADF;;AAIA,gBAAA;AACA;EACE;IACE,0BAAA;IACA,2BAAA;EADF;AACF;AAIA,gBAAA;AACA;EACE;IACE,cAAA;IACA,eAAA;EAFF;AACF;AAKA;EACE,iBAAA;EACA,WAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA,EAAA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,WAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,wCAAA;EACA,wBAAA;UAAA,gBAAA;EACA,kMAAA;EACA,4BAAA;EACA,sCAAA;EACA,yBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,6CAAA;AAHF;;AAMA;EACE,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAHF;;AAMA;EACE,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAHF;;AAMA;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAHF;;AAMA;EACE,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAHF;;AAOA;EACE,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,OAAA;AAJF;;AAOA;EACE,kBAAA;EACA,uBAAA;AAJF;;AAMA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;AAHF;AAKE;EACE,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,OAAA;AAJJ;;AAQA;EACE,WAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AALF;;AAQA;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AALF;;AAQA;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;AALF;;AAQA;EACE,oCAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;AALF;;AAQA;;EAEE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AALF","sourcesContent":[".chart canvas {\n  display: block !important;\n  padding: 20px;\n  position: relative;\n  height: 380px !important;\n  width: auto !important;\n}\n\n.cards-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.card {\n  flex: 1 1 calc(33% - 1rem);\n  max-width: calc(33% - 1rem);\n  min-width: 240px;\n  box-sizing: border-box;\n  padding: 1rem;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px #36f;\n  // transition: all 0.3s ease-in-out;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 3px solid #36f !important;\n}\n\n.card:hover {\n  padding-top: 20px;\n  // transform: translateY(-10px);\n  transform: translateY(-10px) scale(1.02);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n/* Tablet view */\n@media (max-width: 992px) {\n  .card {\n    flex: 1 1 calc(50% - 1rem);\n    max-width: calc(50% - 1rem);\n  }\n}\n\n/* Mobile view */\n@media (max-width: 576px) {\n  .card {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n.rule-id {\n  font-size: 0.9rem;\n  color: #777;\n}\n\n.criteria-block {\n  margin-top: 0.75rem;\n}\n\n.progress-bar-container {\n  display: flex;\n  height: 8px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #e0e0e0;\n}\n\n.progress-bar {\n  height: 100%;\n}\n\n.blue {\n  background-color: #36f;\n}\n\n.red {\n  background-color: red;\n}\n\n.custom-select-container {\n  position: relative;\n  max-width: 200px; /* Adjust as needed */\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#typeFilter {\n  width: 100%;\n  padding: 6px 32px 6px 12px;\n  border: 1px solid #36f;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n  color: #333;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23444' d='M2 0L0 2h4L2 0zM2 5L0 3h4l-2 2z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 8px 10px;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#typeFilter:focus {\n  outline: none;\n  border-color: #36f;\n  box-shadow: 0 0 0 2px rgba(51, 102, 255, 0.2);\n}\n\n.filter-row {\n  display: flex;\n  align-items: end;\n  justify-content: end;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.detailsBtn {\n  color: #36f;\n  background-color: white;\n  padding: 6px 12px;\n  border: 1px solid #36f;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.detailsBtn:hover {\n  color: white;\n  background-color: #36f;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.backBtn {\n  color: #36f;\n  background-color: white;\n  padding: 6px 12px;\n  border: 1px solid #36f;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  // transition: all 0.3s ease;\n}\n\n.backBtn:hover {\n  background-color: #36f;\n  color: white;\n}\n\n.back-button-wrapper {\n  flex: 1;\n}\n\n.card h4 {\n  text-align: center;\n  color: rgb(198, 187, 9);\n}\n.info-row {\n  font-size: 15px;\n  margin: 4px 0;\n  text-align: center;\n\n  .label {\n    min-width: 70px;\n    font-weight: bold;\n  }\n\n  .value {\n    flex: 1;\n  }\n}\n\n.calenderIcons {\n  color: #36f;\n  background-color: white;\n  padding: 6px 12px;\n  border: 1px solid #36f;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.calenderIcons:hover {\n  color: white;\n  background-color: #36f;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.calenderIcons:focus {\n  color: white;\n  background-color: #36f;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.form-popup {\n  display: none;\n  position: fixed;\n  width: 250px;\n  top: 21%;\n  right: 3%;\n  border: 3px solid #f1f1f1;\n  z-index: 9;\n  background-color: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.btn-submit {\n  background-color: #007bff !important;\n  color: white !important;\n  transition: background-color 0.3s ease;\n  margin: 10px;\n}\n\n.btn-submit.btn-disabled,\n.btn-submit:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n  border: none;\n}\n\n.calenderIConCLicked.btn-enabled {\n  color: white;\n  background-color: #36f;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
